import { buildSchema, buildProperty, ExportMappingFunction } from "@camberi/firecms";
import { BlogEntryPreview } from "../custom_schema_view/BlogEntryPreview";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const ecommerceProduct = buildSchema({
    name: "Ecommerce Product",
    properties: {
        name: buildProperty({
            title: "Name",
            validation: { required: true },
            dataType: "string"
        }),

        header: buildProperty({
            title: "Header Image",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
            // description: "Recommended size (200 X 140)",
            // dataType: "string",
            // validation: { required: true },
            // config: {
            //     storageMeta: {
            //         mediaType: "image",
            //         storagePath: "images",
            //         storeUrl: true,
            //         acceptedFiles: ["image/*"],
            //         metadata: {
            //             cacheControl: "max-age=1000000"
            //         }
            //     }
            // }
        }),
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        content: buildProperty({
            title: "Content",
            description: "Example of a complex array with multiple properties as children",
            validation: { required: true },
            dataType: "array",
            columnWidth: 400,
            oneOf: {
                properties: {
                    images: {
                        title: "Images",
                        dataType: "array",
                        of: {
                            dataType: "string",
                            config: {
                                storageMeta: {
                                    mediaType: "image",
                                    storagePath: `images/${new Date().toLocaleDateString('en-CA')}/${new Date().getTime()}`,
                                    acceptedFiles: ["image/*"],
                                    storeUrl: true,
                                    metadata: {
                                        cacheControl: "max-age=1000000"
                                    }
                                },
                                fileName: (context :any) => {
                                    return Math.random()  + "-" + context.file.name;
                                }
                            }
                        },
                        description: "This fields allows uploading multiple images at once and reordering"
                    },
                    text: {
                        dataType: "string",
                        title: "Text",
                        config: {
                            markdown: true
                        }
                    },
                    // products: {
                    //     title: "Products",
                    //     dataType: "array",
                    //     of: {
                    //         dataType: "reference",
                    //         path: "products",
                    //         previewProperties: ["name", "main_image"]
                    //     }
                    // }
                }
            }
        }),
        publishedAt: buildProperty({
            title: "Published At",
            dataType: "timestamp"
        }),
        reviewed: buildProperty({
            title: "Reviewed",
            dataType: "boolean"
        }),
        isFree: buildProperty({
            title: "Is Free",
            dataType: "boolean"
        }),
        productUrl: buildProperty({
            title: "Product Url",
            dataType: "string"
        }),
        currency: buildProperty({
            title: "Currency",
            dataType: "string"
        }),
        price: buildProperty({
            title: "Price",
            dataType: "number"
        }),
        status: buildProperty({
            title: "Status",
            validation: { required: true },
            dataType: "string",
            columnWidth: 140,
            config: {
                enumValues: {
                    published: "Published",
                    draft: "Draft"
                }
            }
        }),
        tags: buildProperty({
            title: "Tags",
            description: "Example of generic array",
            validation: { required: true },
            dataType: "array",
            of: {
                dataType: "string",
                validation: { required: true },
                config: {
                    previewAsTag: true
                }
            }
        }),
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },
        },
    },
    defaultValues: {
        status: "draft",
        order: 0,
        isProduct: false
    }
});

/**
 * Sample field that will be added to the export
 */
export const sampleAdditionalExportColumn: ExportMappingFunction = {
    key: "extra",
    builder: async ({ entity }) => {
        await new Promise(resolve => setTimeout(resolve, 100));
        return "Additional exported value " + entity.id;
    }
};
